import { FetchStatus } from '../util/FetchStatus';

export interface WebContentResult {
  objectID: string;
  title: string;
  url: string;
  content?: string;
  image?: string;
  originalName?: string;
  isPdfContent?: boolean;
  segment?: string;
}

export interface WebContentResults {
  total: number;
  privateTotal: number;
  businessTotal: number;
  status: FetchStatus;
  filterOrder: WebContentFilterOrder;
}

export interface DealerNewsResult {
  objectID: string;
  title: string;
  authors: string[];
  content: string;
  url: string;
  date: string;
  modified: string;
  topics?: string[];
}

export interface OnlineHelpSearchResult {
  id: number;
  title: string;
  highlight: string;
  link: string;
}

export interface SelfServiceSearchGroup {
  objectID: string;
  title: string;
  description: string;
  icon: string;
  url: string;
  app: string;
  keywords: string[];
}

export interface SearchSuggestionResults {
  shopResult: ShopSearchSuggestionResult;
  oaResult: SearchSuggestionResult;
  webResult: SearchSuggestionResult;
}

export interface SuggestionGroup {
  key: string;
  items: SuggestionItem[];
}

export interface SuggestionItem {
  label: string;
  url: string;
}

export interface SearchSuggestionWrapper {
  results: SuggestionGroup[];
  total: number;
  status: FetchStatus;
  queryIds?: {
    shop: string;
    web: string;
    oa: string;
  };
}

export interface SearchSuggestion {
  title: string;
  url: string;
}

interface ShopSearchSuggestionResult {
  queryId: string;
  results: ShopSearchSuggestion[];
}

interface SearchSuggestionResult {
  queryId: string;
  results: SearchSuggestion[];
}

export interface ShopSearchSuggestion {
  url: string;
  displayName: Translation;
  pictures: string[];
}

export interface Translation {
  [key: string]: string;

  et: string;
  ru: string;
}

export enum ProductsSortOrder {
  RELEVANCE = 'RELEVANCE',
  PRICE_ASC = 'PRICE_ASC',
  PRICE_DESC = 'PRICE_DESC',
  NEWEST = 'NEWEST',
}

export enum AllAndArchivedFilterOrder {
  ALL = 'all',
  ARCHIVED = 'archived',
}

export enum WebContentFilterOrder {
  ALL = 'all',
  PRIVATE = 'era',
  BUSINESS = 'ari',
}

export enum DealerNewsFilterOrder {
  ALL = 'all',
  NEWS = 'uudis',
  INSTRUCTIONS = 'juhend',
  CAMPAIGNS = 'kampaaniad',
  TECHNICIAN = 'tehnikule',
  ARCHIVED = 'archived',
}

export interface DealerNewsTopicsResultCounts {
  newsCount: number;
  instructionsCount: number;
  campaignsCount: number;
  technicianCount: number;
}

export interface GeneralContentForSegmentCounts {
  private: number;
  business: number;
}

export enum NewsSortOrder {
  WEIGHT = 'weight',
  DATE = 'date',
}

export enum DealerNewsSortOrder {
  WEIGHT = 'weight',
  DATE = 'date',
  MODIFIED = 'modified',
}

export interface SearchEvent {
  eventType: string;
  eventName: string;
  index: string;
  userToken: string;
  objectIDs: string[];
  queryID: string;
  positions?: number[];
}

export interface SearchResultBase<T> {
  total: number;
  currentPage: number;
  status: FetchStatus;
  queryId?: string;
  results: T[];

  [key: string]: any;
}

export interface SearchNewsResult {
  objectID: string;
  title: string;
  link: string;
  date: string;
  content: string;
}
